import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDTitleText,
  FDBodyText,
  FDLozenge,
  FDPaper,
  FDSecondaryActionButton,
  FDStack,
  FDBox,
} from '@facet-wealth/design';
import { downloadSecureFileFromLink } from 'Helpers/File';

export function NMARSRequestsMobile({ resource }) {
  const requests = useMemo(() => resource.attr('requests').resources().list(), [resource]);
  return (
    <FDStack paddingY={2} direction="column" spacing={1}>
      {requests.map(request => (
        <FDPaper appearance="elevated" padding={2} key={request.id()}>
          <FDStack direction="column" spacing={1}>
            <FDLozenge label={request.attr('status')} color="info" />
            <FDBox>
              <FDTitleText value={request.attr('name')} />
              <FDBodyText size="sm" color="textDisabled" value={`Uploaded on ${request.attr('uploadDate')}`} />
            </FDBox>
            {
                    request.withRelationship(
                      fr.relationships.recommendations.name,
                      (rel) => (
                        <FDSecondaryActionButton
                          onClick={() => {
                            downloadSecureFileFromLink(rel.link('related'), rel.meta('title'));
                          }}
                          label="Download"
                        />
                      ),
                      () => null,
                    )
                  }
          </FDStack>
        </FDPaper>
      ))}
    </FDStack>
  );
}

NMARSRequestsMobile.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
